import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import { Star } from 'lucide-react';
import styles from '../../cards.module.scss';

function ProjectItem({ project, handleClickProject, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === 'grid' ? styles.projectCardGrid : ''}`}
      onClick={handleClickProject}>
      <img
        className={styles.projectImage}
        src={project.main_image?.file ? project.main_image?.file : getImage('img-ph.png')}
        alt={project.main_image?.label ? project.main_image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{project.title}</p>
          <span className={styles.subtitle}>{project.year}</span>
          <span className={styles.subtitle}>
            {project.localisation.country}, {project.localisation.city}
          </span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: project.is_highlight && 'Projet mis en avant',
              icon: Star,
              bgColor: project.is_highlight && 'bg-purple-800'
            }}
            rounded
          />
        </div>
      </div>
    </div>
  );
}

export default ProjectItem;
